import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { first } from "rxjs/operators";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { ApiService } from "src/app/api.service";
import { CookieTovpil } from "src/app/shared/models/CookieTovpil";
import { MatNatReqStsHVO } from "src/app/shared/models/MatNatReqStsHVO";
import { TovpilCrudService } from "src/app/utils/tovpil-crud-service";
import { TovpilFilesService } from "src/app/utils/tovpil-files.service";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";
import { UrlBuilderService } from "src/app/utils/tovpil-url-builder.service";
import { TovpilUtilsService } from "src/app/utils/tovpil-utils.service";
import { UserPreferencesService } from "src/app/utils/user-preferences.service";

@Component({
  selector: "app-mat-nat-req-lst",
  templateUrl: "./mat-nat-req-lst.component.html",
  styleUrls: ["./mat-nat-req-lst.component.scss"],
  providers: [MessageService, ConfirmationService, TovpilLanguageService],
})
export class MatNatReqLstComponent implements OnInit {
  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** PIPES */
  datePipe: DatePipe = new DatePipe("en-US");

  /** LABELS */
  translations: Record<string, string> = {};

  /** DIALOG */
  displayModal: boolean = false;

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** COMPONENT */
  listYears: any[];
  listOrders: any[];

  /**
   * The constructor initializes various services and sets up data forms and configurations based on
   * user preferences.
   * @param {MessageService} messageService - The `messageService` parameter is likely a service that
   * handles messaging functionality within the application. It could be used for displaying
   * notifications, alerts, or other types of messages to the user.
   * @param {ApiService} apiService - The `apiService` parameter in the constructor is likely a service
   * that handles API communication in your application. It could be responsible for making HTTP
   * requests to your backend server, handling responses, and managing data exchange between your
   * frontend and backend systems.
   * @param {AuthenticationService} authenticationService - The `authenticationService` parameter in
   * the constructor is likely a service that handles user authentication and authorization within the
   * application. It is used to authenticate users, manage user sessions, and enforce security
   * policies. This service may interact with backend APIs, validate user credentials, and manage user
   * roles and permissions.
   * @param {FormBuilder} fb - FormBuilder is a service provided by Angular that helps in creating form
   * controls and groups in reactive forms. It simplifies the process of building and managing forms in
   * Angular applications.
   * @param {TovpilUtilsService} tovUtilsService - The `tovUtilsService` parameter in the constructor
   * is likely a service that provides utility functions or methods related to the Tovpil application.
   * It may contain functions for common tasks or operations that are used across different components
   * or services within the application. These utility functions could help with tasks such as
   * @param {UserPreferencesService} userPreferencesService - The `userPreferencesService` parameter in
   * the constructor is a service that is responsible for managing and storing user preferences within
   * the application. It likely provides methods to retrieve, update, and save user-specific settings
   * such as language preferences, theme choices, or any other custom settings that users can configure
   * within the application
   * @param {Router} router - The `router` parameter in the constructor is used for routing in Angular
   * applications. It provides navigation and URL manipulation capabilities in your application. You
   * can use it to navigate to different components or routes within your application.
   * @param {TovpilFilesService} filesService - The `filesService` parameter in the constructor is an
   * instance of `TovpilFilesService`. It is used to handle file-related operations such as uploading,
   * downloading, and managing files within the application. This service likely provides methods and
   * functionalities related to file management that are needed within the component or
   * @param {TovpilLanguageService} translationService - The `translationService` parameter in the
   * constructor is likely used for handling language translation services within the application. It
   * is injected as a dependency in the constructor to provide functionality related to translating
   * text or content into different languages. This service may be responsible for managing language
   * files, providing translations based on the user's
   */
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private tovUtilsService: TovpilUtilsService,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService
  ) {
    this.createDataForm();
    this.initConfigs();

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
   * The function creates a reactive form using Angular's FormBuilder with three form controls.
   */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedYear: new FormControl(null),
      fullComments : new FormControl(null),
    });

    console.debug(
      "MatNatReqLstComponent - REACTIVE FORM: ",
      JSON.stringify(this.globalUserDataForm.getRawValue(), null, 2)
    );
  }

  /**
   * The `initConfigs` function asynchronously initializes global user preferences by consulting
   * cookies using a service method.
   */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
  }

 /**
  * The function `authenticateByZuul` in TypeScript authenticates a user using a login service and
  * performs additional actions based on the response code.
  * @param {string} user - The `user` parameter in the `authenticateByZuul` function is a string that
  * represents the username or user identifier that will be used for authentication. It is typically
  * provided by the user when attempting to log in or access a secure resource.
  * @param {string} password - The `password` parameter in the `authenticateByZuul` function is a
  * string that represents the password input provided by the user for authentication. This password is
  * typically used along with the `user` parameter (which represents the username or user identifier)
  * to authenticate and authorize the user to access certain
  */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  /**
   * The ngOnInit function calls the getSecurity method when the component is initialized.
   */
  ngOnInit(): void {
    this.getSecurity();
  }

  /**
   * The `getSecurity` function retrieves security information, updates it if necessary, and then
   * fetches translated labels and initialization data.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE EN CASO DE QUE SEA NULL
    if (securityControl === null || Object.keys(securityControl).length === 0) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences.preferences = data;
    }

    await this.getTranslatedLabels();
    await this.getInitData();
  }

  /**
   * The function `getTranslatedLabels` asynchronously retrieves translated labels based on user
   * preferences and handles any errors that occur.
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  /**
   * The `getInitData` function retrieves initial data including store information, valid years, and
   * updates the user interface accordingly.
   */
  async getInitData() {
    const storeId = this.globalUserPreferences.preferences.storeId;
    const store = await this.apiService.getStoreById({
      storeId: storeId,
    });
    const years = await this.apiService.getValidYears();
    this.listYears = years;

    this.globalUserDataForm.patchValue({
      selectedCoordination: store.descri,
      selectedYear: years[0],
    });

    await this.getData();
  }

  /**
   * The `getData` function retrieves material request order status data based on user preferences and
   * selected year.
   */
  async getData() {
    // Aquí se incluye el primer servicio que me comentó el ing Abel
    const storeId =
      this.globalUserPreferences.preferences.storeId || null;
      // 0000000009
    const language = this.globalUserPreferences.preferences.language;

    const year = this.globalUserDataForm.get("selectedYear").value.descrip;

    const orders = await this.apiService.getMaterialRequestOrderStatus({
      storeId: storeId,
      year: year,
      language: language,
    });
    this.listOrders = orders.map(order => ({
        ...order,
        seqId : `${order.orderYear}-${order.orderSeq}-${order.supplSeq}`,
        reqDate : this.formatDate(order.reqDate),
        maxRcvDate: this.formatDate(order.maxRcvDate),
        maxSentDate : this.formatDate(order.maxSentDate)
    }));
    this.blocked = false;
  }

  /**
   * The `onChangeYear` function sets the `blocked` flag to true and then fetches data asynchronously.
   */
  async onChangeYear() {
    this.blocked = true;
    await this.getData();
  }

  /**
   * The function formatDate takes a string date input, converts it to a specific date format using
   * utility services, and returns the formatted date or an empty string if the input is null.
   * @param {string} date - The `formatDate` function takes a `date` parameter as a string.
   * @returns The `formatDate` function is returning the formatted date in the TOVPIL date format. If
   * the input `date` is not null, it first converts the string date to a Date object using
   * `this.tovUtilsService.stringToDate(date)`, and then formats this Date object to the TOVPIL date
   * format using `this.tovUtilsService.dateToTovpilDateFormat()`.
   */
  formatDate(date: string) {
    let formatedDate;
    if (date !== null && date != '') {
      formatedDate = this.tovUtilsService.dateToTovpilDateFormatYYMMDD(
        this.tovUtilsService.stringToDate(date)
      );
    } else {
      formatedDate = "";
    }
    return formatedDate;
  }

  /**
   * The function `formatComments` concatenates various comments from an order object and returns them,
   * with a maximum length of 50 characters.
   * @param {any} order - ```typescript
   * @returns The `formatComments` function is returning the concatenated string of
   * `order.internalComments`, `order.vendorComments`, `order.itemComments`, and `order.folioNumbers`.
   * If the length of the resulting string is greater than 50 characters, it is supposed to return a
   * substring of the first 50 characters. However, there is a mistake in the code where the substring
   * operation is not assigned back to
   */
  formatComments(order: any) {
    let comments = order.internalComments ?? "";
    comments += " ";
    comments += order.vendorComments ?? "";
    comments += " ";
    comments += order.itemComments ?? "";
    comments += " ";
    comments += order.folioNumbers ?? "";

    if (comments.length > 50) {
      return comments.substring(0, 49);
    }
    return comments;
  }

  /**
   * The `viewOrderDetail` function navigates to a specific route with query parameters based on the
   * order details provided.
   * @param order - The `order` parameter in the `viewOrderDetail` function seems to be an object
   * containing the following properties:
   */
  viewOrderDetail(order : MatNatReqStsHVO) {
    this.router.navigate(["materials/matNatReqDtl"], {
      queryParams: {
        order : encodeURIComponent(JSON.stringify(order))
      },
    });
  }

  viewFullComment(order) {
    let comments = order.internalComments ?? "";
    comments += " ";
    comments += order.vendorComments ?? "";
    comments += " ";
    comments += order.itemComments ?? "";
    comments += " ";
    comments += order.folioNumbers ?? "";
    
    this.globalUserDataForm.patchValue({
      fullComments : comments
    });
    this.displayModal = true;
  }

  checkCommentLength(order){
    let comments: string = order.internalComments ?? "";
    comments += " ";
    comments += order.vendorComments ?? "";
    comments += " ";
    comments += order.itemComments ?? "";
    comments += " ";
    comments += order.folioNumbers ?? "";
    if(comments.length > 50){
      return true;
    }
    return false;
  }

  exportPdf() {
    try {
      if (this.listOrders === null || this.listOrders.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`,
          life: 3000
        });
      } else {
        const orderNumber = this.translations.lbl_number + " " + this.translations.lbl_order;
        const orderDate = this.translations.lbl_date + " " + this.translations.lbl_order;
        const requiredTo = this.translations.lbl_required + " " + this.translations.lbl_to;
        
        const filteredJSON = this.listOrders.map((order) => ({
          [orderNumber]: order ? (`${order?.orderYear}-${order?.orderSeq}-${order?.supplSeq}` || 'S/N') : 'S/N',
          [this.translations.lbl_applicant]: order ? (order?.storeName || 'S/N') : 'S/N',
          [requiredTo]: order ? (order?.supplName || 'S/N') : 'S/N',
          [orderDate] : order ? (this.formatDate(order?.reqDate) || 'S/N') : 'S/N',
          [this.translations.lbl_language]: order ? (order?.language || 'S/N') : 'S/N',
          [this.translations.lbl_status]: order ? (order?.hdrStatus || 'S/N') : 'S/N',
          [this.translations.lbl_sent_date]: order ? (this.formatDate(order?.maxSentDate) || 'S/N') : 'S/N',
          [this.translations.lbl_receiving_date]: order ? (this.formatDate(order?.maxRcvDate) || 'S/N') : 'S/N',
          [this.translations.lbl_comments]: order ? (this.formatComments(order) || 'S/N') : 'S/N',
        }));

        const keysArray = filteredJSON.map((order) => Object.keys(order));
        const valuesArray = filteredJSON.map((order) => Object.values(order));

        let fileName = `${this.translations.lbl_orders_request}_${this.globalUserDataForm.get('selectedCoordination').value}_`;
        this.filesService.tovpilExportPDF(keysArray[0], valuesArray, fileName);
      }
    } catch (error) {
      console.error("An error occurred while exporting to PDF:", error);
      this.messageService.add({
        severity: 'error',
        summary: `${this.translations.lbl_error} ${this.translations.lbl_export_to_pdf}`,
        detail: `${this.translations.lbl_then_try_it_again}`,
        life: 5000
      });
    }
  }

  exportExcel() {
    try {
      if (this.listOrders === null || this.listOrders.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`,
          life: 3000
        });
      } else {
        const orderNumber = this.translations.lbl_number + " " + this.translations.lbl_order;
        const orderDate = this.translations.lbl_date + " " + this.translations.lbl_order;
        const requiredTo = this.translations.lbl_required + " " + this.translations.lbl_to;

        const filteredJSON = this.listOrders.map((order) => ({
          [orderNumber]: order ? (`${order?.orderYear}-${order?.orderSeq}-${order?.supplSeq}` || 'S/N') : 'S/N',
          [this.translations.lbl_applicant]: order ? (order?.storeName || 'S/N') : 'S/N',
          [requiredTo]: order ? (order?.supplName || 'S/N') : 'S/N',
          [orderDate] : order ? (this.formatDate(order?.reqDate) || 'S/N') : 'S/N',
          [this.translations.lbl_language]: order ? (order?.language || 'S/N') : 'S/N',
          [this.translations.lbl_status]: order ? (order?.hdrStatus || 'S/N') : 'S/N',
          [this.translations.lbl_sent_date]: order ? (this.formatDate(order?.maxSentDate) || 'S/N') : 'S/N',
          [this.translations.lbl_receiving_date]: order ? (this.formatDate(order?.maxRcvDate) || 'S/N') : 'S/N',
          [this.translations.lbl_comments]: order ? (this.formatComments(order) || 'S/N') : 'S/N',
        }));

        let fileName = `${this.translations.lbl_orders_request}_${this.globalUserDataForm.get('selectedCoordination').value}_`;
        this.filesService.tovpilExportXLSX(filteredJSON, fileName);
      }
    } catch (error) {
      console.error("An error occurred while exporting to Excel:", error);
      this.messageService.add({
        severity: 'error',
        summary: `${this.translations.lbl_error} ${this.translations.lbl_export_to_excell}`,
        detail: `${this.translations.lbl_then_try_it_again}`,
        life: 5000
      });
    }
  }

  goBack(){
    window.close();
  }

}
